/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { StateResource } from '@common/tech-shared';
import { Component, Input } from '@angular/core';
import { cva } from 'class-variance-authority';
import { UserProfileResource } from '../user-profile.model';
import { getUserName } from '../user-profile.util';

export const userNameVariants = cva('block break-words text-start');

@Component({
  selector: 'alfa-user-profile-name',
  host: { class: 'min-w-0' },
  templateUrl: './user-profile-name.component.html',
  standalone: true,
})
export class UserProfileNameComponent {
  @Input()
  public set userProfileResourceStateResource(userProfileStateResource: StateResource<UserProfileResource>) {
    this.userProfileStateResource = userProfileStateResource;
    this.userName = getUserName(userProfileStateResource.resource);
  }

  userProfileStateResource: StateResource<UserProfileResource>;
  userName: string;

  protected readonly userNameVariants = userNameVariants;
}
